import { __values } from 'tslib';

var pick = function (o, list) {
    var e_1, _a;
    var picked = {};
    try {
        for (var _b = __values(Object.keys(o)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var key = _c.value;
            if (list.includes(key)) {
                picked[key] = o[key];
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return picked;
};
var wait = function (ms) {
    return new Promise(function (resolve) {
        setTimeout(resolve, ms);
    });
};

export { pick, wait };
//# sourceMappingURL=index.js.map
